import vip from './vip.png';
import opal from './opal.png';
import ruby from './ruby.png';
import topaz from './topaz.png';
import member from './member.webp';
import emerald from './emerald.png';
import diamond from './diamond.png';
import amethyst from './amethyst.png';
import sapphire from './sapphire.png';
import aquamarine from './aquamarine.png';

export default {
  vip,
  opal,
  ruby,
  topaz,
  member,
  emerald,
  diamond,
  amethyst,
  sapphire,
  aquamarine,
};
